import { Container, Spinner } from "@jds/core";
import React from "react";

export default function Loader(props) {
  return (
    <Container
      horizontalAlign="center"
      verticalAlign="center"
      fullWidth
      {...props?.containerProps}
    >
      <Spinner {...props} />
    </Container>
  );
}
